import {
  Container,
  Heading,
  Text,
  VStack,
  Box,
  HStack,
  Button,
  useColorModeValue,
  Icon,
  Flex,
  Badge,
} from '@chakra-ui/react';
import { ArrowRight, Users, MapPin } from '@phosphor-icons/react';
import { Link } from 'react-router-dom';
// Removed unused Icon import

export const AboutCTASection = () => {
  // Use theme tokens directly
  const sectionBg = useColorModeValue('bg.surface', 'bg.surface');
  const headingColor = useColorModeValue('text.default', 'text.default'); // Use default text color for heading here
  const textColor = useColorModeValue('text.default', 'text.default');
  const borderColor = useColorModeValue('border.default', 'border.default');

  return (
    <Box bg={useColorModeValue('bg.default', 'bg.default')} py={{ base: 16, md: 20 }}>
      <Container maxW="container.lg">
        <Box
          bg={sectionBg}
          p={{ base: 10, md: 16 }}
          borderRadius="xl"
          boxShadow="2xl"
          textAlign="center"
          borderWidth="3px"
          borderColor={borderColor}
          position="relative"
          transform="rotate(-0.5deg)"
          _hover={{ transform: "rotate(0deg)", transition: "all 0.5s ease" }}
          _before={{
            content: '""',
            position: 'absolute',
            top: 0, left: 0, right: 0, bottom: 0,
            opacity: useColorModeValue(0.12, 0.18),
            pointerEvents: 'none',
            bgImage: 'var(--texture-linen)',
            bgRepeat: 'repeat',
            bgSize: '250px',
            bgBlendMode: useColorModeValue('soft-light', 'multiply'),
            borderRadius: 'inherit',
            zIndex: 0,
          }}
          _after={{
            content: '""',
            position: 'absolute',
            top: '15px',
            right: '15px',
            width: '80px',
            height: '80px',
            bgImage: 'var(--texture-compass)',
            bgRepeat: 'no-repeat',
            bgPosition: 'center',
            bgSize: 'contain',
            opacity: useColorModeValue(0.3, 0.4),
            pointerEvents: 'none',
            zIndex: 1,
          }}
        >
          <VStack spacing={8} position="relative" zIndex={2}>
            {/* Enhanced Header */}
            <VStack spacing={4}>
              <Badge
                bg={useColorModeValue('interactive.primary', 'interactive.primary')}
                color="white"
                fontSize="sm"
                px={4}
                py={2}
                borderRadius="md"
                fontFamily="heading"
                letterSpacing="wide"
              >
                Join Our Community
              </Badge>
              
              <Heading 
                as="h2" 
                size="2xl" 
                fontFamily="accent" 
                color={headingColor}
                letterSpacing="wide"
                lineHeight="shorter"
              >
                Join Our Community Today
              </Heading>
            </VStack>

            {/* Enhanced Description */}
            <VStack spacing={4}>
              <Text 
                fontSize={{ base: 'lg', md: 'xl' }} 
                maxW="3xl" 
                fontFamily="body" 
                color={textColor}
                lineHeight="tall"
                fontStyle="italic"
              >
                Become part of a global network dedicated to documenting and preserving megalithic heritage 
                for future generations. Connect with researchers, enthusiasts, and site visitors to share 
                knowledge and contribute to our growing database of ancient sites.
              </Text>
              
              <Flex align="center" gap={6} flexWrap="wrap" justify="center" mt={4}>
                <Flex align="center" gap={2}>
                  <Icon as={Users} boxSize={5} color={useColorModeValue('interactive.primary', 'interactive.primary')} />
                  <Text fontSize="sm" color={useColorModeValue('text.muted', 'text.muted')} fontFamily="body">
                    Global Community
                  </Text>
                </Flex>
                <Flex align="center" gap={2}>
                  <Icon as={MapPin} boxSize={5} color={useColorModeValue('interactive.primary', 'interactive.primary')} />
                  <Text fontSize="sm" color={useColorModeValue('text.muted', 'text.muted')} fontFamily="body">
                    Worldwide Sites
                  </Text>
                </Flex>
              </Flex>
            </VStack>

            {/* Enhanced Action Buttons */}
            <VStack spacing={4} pt={4}>
              <HStack spacing={6} flexWrap="wrap" justify="center">
                <Button
                  as={Link}
                  to="/signup"
                  size="lg"
                  variant="primary"
                  rightIcon={<Icon as={ArrowRight} weight="bold" />}
                  fontFamily="heading"
                  letterSpacing="wide"
                  px={8}
                  py={6}
                  fontSize="lg"
                  _hover={{
                    transform: 'translateY(-3px)',
                    boxShadow: 'xl',
                  }}
                >
                  Sign Up
                </Button>
                
                <Button
                  as={Link}
                  to="/map"
                  size="lg"
                  variant="journal"
                  rightIcon={<Icon as={MapPin} weight="bold" />}
                  fontFamily="heading"
                  letterSpacing="wide"
                  px={8}
                  py={6}
                  fontSize="lg"
                  _hover={{
                    transform: 'translateY(-3px)',
                    boxShadow: 'lg',
                  }}
                >
                  Explore the Map
                </Button>
              </HStack>
              
            </VStack>
          </VStack>
        </Box>
      </Container>
    </Box>
  );
};